import { toNumber } from "./format";
import { offerCsvCell } from "./offerCsv";

/** Numeric evidence stays numeric in de-AT Excel; all source text remains inert. */
export function historyCsvNumber(value: string | number | null | undefined): number | null {
  const number = toNumber(value);
  return number !== null && Number.isFinite(number) ? number : null;
}

export function historyCsv(rows: readonly (readonly unknown[])[]): string {
  const cell = (value: unknown): string => {
    if (typeof value === "number" && Number.isFinite(value)) {
      return `"${new Intl.NumberFormat("de-AT", { useGrouping: false, maximumFractionDigits: 8 }).format(value)}"`;
    }
    return offerCsvCell(value);
  };
  return "\uFEFF" + rows.map(row => row.map(cell).join(";")).join("\r\n");
}
